import $ from 'jquery';
import Registry from './Registry';
import Container from 'ecore/base/Container';

/**
 * Main is the entry point for webpack.
 * This class sets up the environment and creates any widgets that are on the page.
 */
new class Main extends Container {

    constructor() {
        super();
        this.setupPolyfills();
        this.setupRegistry();
        this.constructModules();
    }

    setupPolyfills() {
        $.support.cors = true;
        if (!window.console) {
            window.console = {
                log() {},
                debug() {},
                warn() {},
                info() {},
                assert() {},
                error() {},
                dir() {},
                clear() {},
                profile() {},
                profileEnd() {}
            };
        }

        /*
         ie9 doesn't have console.debug
         */
        if (!window.console.debug) {
            window.console.debug = window.console.log;
            window.is_probably_ie9 = true;
        }
    }

    setupRegistry() {
        const defaultEtouches = {
            vars: {},
            classes: {
                Registry
            },
            widgets: {},
            objs: {},
            notify: Registry.notify,
            autoAdjust: Registry.autoAdjust,
            reload: Registry.reload,
            impress_resize: []
        };
        if(typeof(top.__etouches) === "undefined"){
            top.__etouches = defaultEtouches;
        } else {
            for(let x in defaultEtouches) {
                if (!defaultEtouches.hasOwnProperty(x)) {
                    continue;
                }
                top.__etouches[x] = defaultEtouches[x];
            }
        }

        Registry.initClass();

        $("script").each(function(i, e){
            if (e.src.match(/\/widgets\/static\/embed\/embed-/)) {
                let match = e.src.match(/^(.*)\/widgets\/static\/embed\/embed-/);
                return Registry.baseURL = match[1];
            }
        });

        Registry.debug = this.debug;

        if (Registry.debug || window._in_ereg) {
            Registry.widget_link = "widgets";
        } else {
            Registry.widget_link = "_widgets";
        }

        Registry.constructModules = this.constructModules;
    }

    constructModules() {
        let widgets = $(".aventri-widget, .etouches-widget");
        $(widgets).each(function(i, obj){
            let args = $(obj).data();
            if (args.ereg) {
                Registry.ereg = true;
            }
            if (args.type) {
                args.container = obj;
                let widget = Registry.create(args.type, args);
                if (top.__etouches.objs["Widget"] === undefined) {
                    top.__etouches.objs["Widget"] = [];
                }
                top.__etouches.objs["Widget"].push(widget);
                return widget.display();
            }
        });
    }
};




// WEBPACK FOOTER //
// ./src/embed/Main.es6